import React, { FC, Fragment } from 'react';
import { Box, Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { isEqual } from 'lodash';

import { EmptyState, Layouts, Loaders, PaddedPaper } from 'components';
import { ContentProvider } from 'providers';

import { useSearchES } from '../hooks';
import { Loader } from '../components';
import { PostCard } from '../components/PostCard';
import { initialPostFilter, useSearchESContext } from '../SearchESContext';

const SearchResultsV2: FC = () => {
  const { t } = useTranslation();
  const { state } = useSearchESContext();

  const query = new URLSearchParams(location.search);
  const term = query.get('q');

  const { results, isEmpty, isExhausted, isInitialLoad, sentinelRef } = useSearchES({
    data: { ...state, search_string: term },
  });

  const isFilterEmpty = isEqual(state.post_filter, initialPostFilter);

  function renderMain() {
    if (isInitialLoad) {
      return <Loader />;
    }

    if (isEmpty) {
      return <EmptyState name="search" />;
    }

    return (
      <Fragment>
        <Box marginBottom={2}>
          <PaddedPaper padding={16} elevation={0}>
            <Typography variant="h4">{t('common:post_plural')}</Typography>
          </PaddedPaper>
        </Box>

        <Grid container direction="column" spacing={2}>
          {results.posts.map(post => (
            <ContentProvider key={post.content_id} value={post}>
              <Grid item>
                <PostCard />
              </Grid>
            </ContentProvider>
          ))}
        </Grid>

        {!isExhausted && (
          <div ref={sentinelRef}>
            <Loaders.Standard />
          </div>
        )}
      </Fragment>
    );
  }

  return (
    <Box marginTop={isFilterEmpty ? 11 : 16}>
      <Layouts.App1Column desktopSize={9} main={renderMain()} />
    </Box>
  );
};

export default SearchResultsV2;
